import React from 'react';
import { ART_COSMETICS } from './artManifest';

/**
 * A cosmetic drawn from its voxel art rather than hand-built SVG.
 *
 * The art is made from each item's own 3D model (petlings-ios-app/scripts/
 * pet-art), so the icon in the shop is the thing the pet wears in 3D, and it
 * is the same picture the iOS app shows.
 */

/** Ids the site uses that differ from the art's file names. */
const ALIASES = {
  candy_sprinkles_tail: 'candy_sprinkles',
  ghost_wisps_trail: 'ghost_wisps',
  musical_note_trail: 'musical_note',
};

export function cosmeticArtId(cosmeticId) {
  const id = ALIASES[cosmeticId] || cosmeticId;
  return ART_COSMETICS.has(id) ? id : null;
}

const components = {};

export function artCosmeticComponent(cosmeticId) {
  const id = cosmeticArtId(cosmeticId);
  if (!id) return null;
  if (!components[id]) {
    const src = `/cosmetics/art/png/${id}.png`;
    const ArtCosmetic = ({ size = 60, className = '' }) => (
      <img
        src={src}
        width={size}
        height={size}
        className={className}
        alt=""
        draggable={false}
        style={{ objectFit: 'contain', display: 'block', userSelect: 'none' }}
      />
    );
    ArtCosmetic.displayName = `ArtCosmetic(${id})`;
    components[id] = ArtCosmetic;
  }
  return components[id];
}
